<section [ngClass]="data.type" class="toaster">
  <div class="toaster-wrap">
    <div class="toaster-icon">
      <img
        [src]="imageSettings[data.type].url"
        [style.height]="imageSettings[data.type].height || ''"
        [style.width]="imageSettings[data.type].width || ''"
        alt="icon"
      />
    </div>
    <div class="toaster-info">
      @if (data.title) {
        <p [innerHTML]="data.title | translate" class="title"></p>
      }
      @if (data.content?.message) {
        <p [translate]="'errors.' + data.content!.message" class="subtitle"></p>
      }
      @if (data.content?.loggerCode) {
        <p
          [innerHTML]="'errors.unexpectedError' | translate : { code: data.content!.loggerCode } | sanitizeHtml"
          class="subtitle"
        ></p>
      }

      @if (data.content?.errors?.length) {
        @for (error of data.content!.errors; track error) {
          <p class="subtitle">
            <span [translate]="'client.' + error.field"></span>:
            <span [translate]="error.message" class="pl-1"></span>
          </p>
        }
      }
    </div>
    <div class="toaster-buttons">
      <div (click)="close()" class="toaster-btn cursor-pointer"></div>
    </div>
  </div>
</section>
